import ElementsSelector from './elements_selector'
import connect from './connect'

export default connect(ElementsSelector)
